import { Rect } from '~/core/shapes/Rect';
import { applyLinearGradient, createInnerShadowContainer } from './Utils';
import { logger } from './Logger';
import { Text } from '~/core/shapes/Text';
import { FontFamilyType, SpriteSheetLeaderboardElementName } from '~/enum';
import { Table } from './Table';
import { hexadecimal, numberFormat } from '~/utils/common';
import { Image } from '~/core/shapes/Image';
import { LeaderboardItemType } from '../enum/leaderboard';
const ColorRanked = {
    Top1: '#FFD700',
    Top2: '#C2ECF0',
    Top3: '#F1B469',
    Other: hexadecimal('#FFFFFF')(64),
};
class LeaderboardModel {
    constructor(textureData, spriteImage) {
        this.textureData = textureData;
        this.spriteImage = spriteImage;
        this.stageWidth = 0;
        this.stageHeight = 0;
        // enum LeaderboardState
        this.LeaderboardMargin = {
            horizontal: 12,
            vertical: 16,
        };
        this.textTitle = 'Xếp hạng';
        this.textEmpty = 'Bảng xếp hạng chưa có người dẫn đầu.';
        this.headerTableTitles = ['Top', 'Người chơi', 'Tiền Thắng'];
        // Elements
        this.container = null;
        this.innerShadowContainer = null;
        this.title = null;
        this.rankingImages = [];
        this.btnClose = null;
        this.boxNotFound = null;
        this.iconNotFound = null;
        this.textNotFound = null;
        //   private leaderboardTable: Table<LeaderboardEntry> | null = null;
        // Sample data
        this.leaderboardData = [];
        this.genColorTextRank = (rank) => {
            switch (rank) {
                case 1:
                    return ColorRanked.Top1;
                case 2:
                    return ColorRanked.Top2;
                case 3:
                    return ColorRanked.Top3;
                default:
                    return ColorRanked.Other;
            }
        };
        this.tableColumns = [];
        // public spriteImage: HTMLImageElement // public textureData: Record<string, SpriteElement>,
        this.layer = null;
        this.group = null;
        this.stage = null;
    }
    // Setup stage, layer, and group
    setupStageLayerGroup(stage, layer, group) {
        this.layer = layer;
        this.group = group;
        this.stageWidth = stage.width();
        this.stageHeight = stage.height();
        this.stage = stage;
        logger.info(`LeaderboardModel setup with stage width: ${this.stageWidth}, height: ${this.stageHeight}`);
    }
    getStage() {
        return this.stage;
    }
    setupLeaderboardData(data) {
        this.leaderboardData = data;
    }
    setupTableProps(title, textEmpty, headerTableTitles) {
        this.textTitle = title;
        this.textEmpty = textEmpty;
        this.headerTableTitles = headerTableTitles;
    }
    init() {
        const { CloseBtn, BoxNotFound, IconNotFound } = SpriteSheetLeaderboardElementName;
        // Container
        this.container = new Rect({
            x: 0,
            y: 0,
            width: this.stageWidth,
            height: this.stageHeight,
            cornerRadius: 8,
            fill: '#061829',
        });
        const { innerShadows } = createInnerShadowContainer({
            width: this.stageWidth,
            height: this.stageHeight,
            borderRadius: 8,
            shadowDepth: 3,
            shadowOpacity: 0.32,
            shadowColor: '#49D2FF',
        });
        this.innerShadowContainer = innerShadows;
        // this.innerShadowContainer = innerShadows;
        applyLinearGradient(this.layer, this.container, {
            strokeWidth: 1,
            strokeGradient: {
                colors: ['#DDDCDB', '#F4F3F1', '#B5B4B4', '#666666'],
                stops: [0, 0.47, 0.93, 1],
            },
            borderRadius: 8,
            opacity: 0.32,
        });
        // Title
        this.title = new Text({
            x: this.LeaderboardMargin.horizontal,
            y: this.LeaderboardMargin.vertical,
            text: this.textTitle,
            fontSize: 20,
            fill: '#FFFFFF',
            fontFamily: FontFamilyType.BOLD,
        });
        // Btn Close
        const btnCloseData = this.textureData[CloseBtn];
        this.btnClose = new Image({
            x: this.stageWidth - this.LeaderboardMargin.horizontal - 32,
            y: 8,
            width: 32,
            height: 32,
            image: this.spriteImage,
            crop: {
                x: btnCloseData.sx,
                y: btnCloseData.sy,
                width: btnCloseData.sWidth,
                height: btnCloseData.sHeight,
            },
        });
        // Box Not Found
        const boxNotFoundData = this.textureData[BoxNotFound];
        this.boxNotFound = new Image({
            x: Math.round(this.stageWidth / 2 - boxNotFoundData.dWidth / 2),
            y: Math.round(this.stageHeight / 2 - boxNotFoundData.dHeight / 2),
            width: boxNotFoundData.dWidth,
            height: boxNotFoundData.dHeight,
            image: this.spriteImage,
            crop: {
                x: boxNotFoundData.sx,
                y: boxNotFoundData.sy,
                width: boxNotFoundData.sWidth,
                height: boxNotFoundData.sHeight,
            },
        });
        // Icon Not Found
        const iconNotFoundData = this.textureData[IconNotFound];
        this.iconNotFound = new Image({
            x: Math.floor(this.stageWidth / 2 - iconNotFoundData.dWidth / 2),
            y: Math.round(this.stageHeight / 2 - iconNotFoundData.dHeight / 2) - 10,
            width: iconNotFoundData.dWidth,
            height: iconNotFoundData.dHeight,
            image: this.spriteImage,
            crop: {
                x: iconNotFoundData.sx,
                y: iconNotFoundData.sy,
                width: iconNotFoundData.sWidth,
                height: iconNotFoundData.sHeight,
            },
        });
        // Text Not Found
        this.textNotFound = new Text({
            x: Math.round(this.stageWidth / 2),
            y: this.iconNotFound.y() + this.iconNotFound.height() + 2,
            text: this.textEmpty,
            fontSize: 16,
            fill: '#FFFFFF',
            fontFamily: FontFamilyType.REGULAR,
            align: 'center',
            width: 200,
            offsetX: 100,
            shadowColor: '#2CCEFF',
            shadowBlur: 4,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
        });
        // Table columns
        const tableWidth = this.stageWidth - this.LeaderboardMargin.horizontal * 2;
        const widthColumnRank = 60;
        const widthColumnName = Math.round((tableWidth - widthColumnRank) * 0.46);
        const widthColumnWonStake = tableWidth - widthColumnName - widthColumnRank;
        this.tableColumns = [
            {
                key: LeaderboardItemType.Rank,
                header: this.headerTableTitles[0],
                width: widthColumnRank,
                align: 'center',
                renderer: (value, _, rowIndex) => ({
                    custom: (cell, config) => {
                        const rankImage = this.rankingImages[rowIndex];
                        if (rankImage) {
                            rankImage.setAttrs({
                                x: Math.floor(config.columnWidth / 2 - rankImage.width() / 2),
                                y: Math.floor(config.rowHeight / 2 - rankImage.height() / 2),
                            });
                            cell.add(rankImage);
                        }
                    },
                }),
            },
            {
                key: LeaderboardItemType.Name,
                header: this.headerTableTitles[1],
                width: widthColumnName,
                align: 'left',
                renderer: value => ({
                    text: value,
                    fontSize: 16,
                    fontFamily: FontFamilyType.SEMIBOLD,
                    shadow: {
                        color: hexadecimal('#000000')(25),
                        blur: 1,
                        offsetX: 1,
                        offsetY: 1,
                    },
                }),
            },
            {
                key: LeaderboardItemType.WonStake,
                header: this.headerTableTitles[2],
                width: widthColumnWonStake,
                align: 'right',
                renderer: (value, _, rowIndex) => ({
                    text: numberFormat(value),
                    color: this.genColorTextRank(rowIndex + 1),
                    fontFamily: FontFamilyType.SEMIBOLD,
                    fontSize: 16,
                }),
            },
        ];
        // Ranking images
        for (let i = 1; i <= 10; i++) {
            const ranking = this.textureData[`leader-board-top${i}`];
            const image = new Image({
                x: this.LeaderboardMargin.horizontal + 10,
                y: this.LeaderboardMargin.vertical + 40 + (i - 1) * 40,
                width: 24,
                height: 24,
                image: this.spriteImage,
                crop: {
                    x: ranking.sx,
                    y: ranking.sy,
                    width: ranking.sWidth,
                    height: ranking.sHeight,
                },
            });
            this.rankingImages.push(image);
        }
    }
    //  Render the leaderboard
    renderContainer() {
        if (this.container) {
            this.group.add(this.container);
        }
        else {
            throw new Error('Container is not initialized');
        }
        if (this.innerShadowContainer) {
            this.innerShadowContainer.forEach(shadow => {
                this.group.add(shadow);
            });
        }
        else {
            throw new Error('Inner shadow container is not initialized');
        }
    }
    // Render title the leaderboard
    renderTitle() {
        if (this.title) {
            this.group.add(this.title);
        }
        else {
            throw new Error('Title is not initialized');
        }
    }
    // Render btn close
    renderBtnClose() {
        if (this.btnClose) {
            this.group.add(this.btnClose);
        }
        else {
            throw new Error('Close button is not initialized');
        }
    }
    renderRowBg(width, height, color) {
        const rowBg = new Rect({
            x: 1,
            y: 1,
            width: width - 2,
            height: height,
            cornerRadius: 4,
        });
        applyLinearGradient(this.layer, rowBg, {
            strokeWidth: 1,
            strokeGradient: {
                colors: [color, color],
                stops: [0, 1],
                opacity: [1, 0],
            },
            borderRadius: 4,
            strokeLinearGradientConfig: {
                startX: 0,
                startY: 0,
                endX: Math.round(rowBg.width() * 0.65),
                endY: 0,
            },
        });
        const gradient = this.layer
            .getContext()
            .createLinearGradient(-rowBg.width() / 2, 0, Math.round(rowBg.width() * 0.75), 0);
        gradient.addColorStop(0, color);
        gradient.addColorStop(0.2, hexadecimal(color)(0));
        gradient.addColorStop(1, '#101F2D');
        rowBg.fill(gradient);
        const heightRectLeft = Math.round(rowBg.height() * 0.5);
        const yRectLeft = Math.round(rowBg.y() + (rowBg.height() - heightRectLeft) / 2);
        const rectLeft = new Rect({
            x: rowBg.x(),
            y: yRectLeft,
            width: 3,
            height: heightRectLeft,
            fill: color,
            cornerRadius: 2,
        });
        return [rowBg, rectLeft];
    }
    renderRowBgsRanked(width, height) {
        return {
            1: this.renderRowBg(width, height, '#E7EA29'),
            2: this.renderRowBg(width, height, '#E7E9EC'),
            3: this.renderRowBg(width, height, '#E7B061'),
        };
    }
    renderNotFound() {
        if (this.boxNotFound && this.iconNotFound && this.textNotFound) {
            this.group.add(this.boxNotFound);
            this.group.add(this.iconNotFound);
            this.group.add(this.textNotFound);
        }
        else {
            throw new Error('Box Not Found or Icon Not Found is not initialized');
        }
    }
    renderBoxNotFoundIfEmpty() {
        var _a, _b;
        if (this.leaderboardData.length === 0) {
            this.renderNotFound();
        }
        else {
            (_a = this.boxNotFound) === null || _a === void 0 ? void 0 : _a.destroy();
            (_b = this.iconNotFound) === null || _b === void 0 ? void 0 : _b.destroy();
        }
    }
    renderTable() {
        if (this.leaderboardData.length === 0) {
            this.renderBoxNotFoundIfEmpty();
            return;
        }
        const margin = this.LeaderboardMargin.horizontal;
        const tableWidth = this.stageWidth - margin * 2;
        const tableHeight = this.stageHeight - margin * 2 - 50; // 50px for title space
        new Table(this.layer, {
            x: margin,
            y: 60, // Leave space for title
            headerHeight: 40,
            rowHeight: 40,
            cellPadding: 8,
            width: tableWidth,
            height: tableHeight,
            columns: this.tableColumns,
            rowBgs: this.renderRowBgsRanked(tableWidth, 36),
            data: this.leaderboardData,
            fontFamily: FontFamilyType.REGULAR,
            headerFontSize: 16,
            headerTextColor: hexadecimal('#FFFFFF')(75),
            borderWidth: 0,
            scrollable: false,
            headerBackground: '#061829',
            rowBackground: '#061829',
            alternateRowBackground: '#101F2D',
        });
    }
    renderLeaderboard() {
        this.renderContainer();
        this.renderTitle();
        this.renderBtnClose();
        this.renderTable();
        this.layer.batchDraw();
    }
}
export default LeaderboardModel;
